export const METRICS_BREAKPOINTS = [
    { label: 'D', value: 'DAY' },
    { label: 'W', value: 'WEEK' },
    { label: 'M', value: 'MONTH' }
];

export const METRICS_CHART_TYPE = [
    { label: 'Influencer', value: 'INFLUENCER', id: 'influencers' },
    { label: 'Business', value: 'BUSINESS', id: 'business' },
    { label: 'Jobs', value: 'JOB', id: 'jobs' },
    { label: 'Platforms', value: 'PLATFORM_TYPE', id: 'platforms' },
    { label: 'Ads', value: 'ADS', id: 'ads' },
]